import { BooleanInput, Filter, SearchInput, usePermissions } from "react-admin";
import React, { useMemo } from "react";

import CompanyTypeEntryInput from "../component/input/CompanyTypeEntryInput";
import MirCodeInput from "./inputs/MirCodeInput";
import { StateInput } from "ra-friendsofbabba";

const Filters = (props) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = useMemo(
    () => loaded && permissions(["admin", "tro", "manager", "mir"]),
    [loaded, permissions]
  );

  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn fullWidth />
      {isAdmin && (
        <StateInput
          emptyText="ra.action.all"
          source="state"
          alwaysOn
          fullWidth
        />
      )}
      {isAdmin && <BooleanInput source="filled" defaultValue={true} />}
      {isAdmin && <CompanyTypeEntryInput source="company_type_entry_id" />}
      {isAdmin && <MirCodeInput source="mir_code" />}
      {isAdmin && <BooleanInput source="logged_in" defaultValue={true} />}
    </Filter>
  );
};
export default Filters;
